/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import {
  faCoins,
  faMagnifyingGlass,
  faPen,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import ContactsSimpleSearch from "./ContactsSimpleSearch";
import Contacts from "./Contacts";
import ContactsIcon from "../../assets/icons/contacts_main.svg2";
import BulkIcon from "../../assets/icons/bulk_manage.svg2";
import ManageFieldIcon from "../../assets/icons/Icon_Library/application icons/general/manage_fields.svg2";

import AddIcon from "../../assets/icons/contact_edit.svg2";
import { setCurrentModal } from "../store/slices/modalsSlice";
import WhiteButton from "../Common/WhiteButton";
import Subheading from "../Common/Subheading";
import BulkAssignAssetsModal from "./BulkAssignAssetsModal";
import { isUserPermitted } from "../helpers/pageProps";
import { Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import BulkEditModal from "./BulkEditModal";
import { proxyAPI } from "../proxyAPI";
import {
  useDeleteAllContactsMutation,
  useGetContactFieldsQuery,
} from "../store/slices/contactsSlice";
import BulkAssignLocationModal from "./BulkAssignLocationModal";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

const emptyFilters = [
  // Word search
  {
    values: [""],
    is_or: true,
    fields: [],
    formats: ["card", "primary"],
    order: 0,
    operator: "prefix",
  },
  // Status filter
  {
    fields: ["status"],
    formats: [],
    isOr: false,
    offset: "0",
    offsetFrom: "fixed",
    offsetType: "positive",
    offsetUnit: "day",
    operator: "is",
    order: 0,
    thread: "CurrentThread",
    timeZone: "",
    timeZoneFrom: "fixed",
    valueId: "",
    values: ["active"],
    valueType: "fixed",
  },
];

export default function ContactsPage({ isModal }) {
  const [filters, setFilters] = useState(
    localStorage.getItem("ContactPageFilters")
      ? JSON.parse(localStorage.getItem("ContactPageFilters"))
      : emptyFilters
  );

  useEffect(() => {
    localStorage.setItem("ContactPageFilters", JSON.stringify(filters));
  }, [filters]);

  const dispatch = useDispatch();
  const setEditedContactData = (data) => {
    dispatch(setCurrentModal({ modal: "editContact", data }));
  };
  const [selectedContacts, setSelectedContacts] = useState([]);

  const confirmDialog = useConfirmDialog();
  const {
    data: contactFields,
    isFetching,
    isLoading,
  } = useGetContactFieldsQuery();

  const deleteSelected = async () => {
    if (
      (await confirmDialog(
        "Remove contacts",
        `Are you sure you want to remove ${selectedContacts.length} contacts?`
      )) === false
    ) {
      return;
    }
    const data = await proxyAPI({
      prefix: "contacts/v1",
      url: "delete",
      method: "POST",
      body: { uuid: selectedContacts },
    });
    if (data) {
      setFilters((p) => [...p]);
      setSelectedContacts([]);
      toast.success(
        "Delete request added to the queue. Please check back later."
      );
    }
  };

  const [deleteAllContacts, { isLoading: isDeletingAll }] =
    useDeleteAllContactsMutation();

  const handleDeleteAll = async () => {
    if (
      !(await confirmDialog(
        "Remove contacts",
        `Are you sure you want to remove ALL contacts from your account? 
                          This action cannot be undone.`
      ))
    ) {
      return;
    }
    try {
      await deleteAllContacts();
    } catch (error) {}
  };

  return (
    <div>
      <FullScreenLoadingIndicator loading={isDeletingAll} />
      <div className="d-flex justify-content-between">
        <div className="d-flex justify-content-between align-items-center">
          <Subheading
            Icon={ContactsIcon}
            heading="Contacts"
            subheading="Manage your contacts"
          />
        </div>
        {!isModal && (
          <WhiteButtonDropdown toggleHeading={"Actions"} toggleSubheading={"Contacts"}>
            <WhiteButton
              as="RRLink"
              to="/assets/contacts/add"
              icon={AddIcon}
              heading="Add"
              subheading="Contact"
              disabled={!isUserPermitted("edit_contact")}
              title={
                isUserPermitted("edit_contact")
                  ? "Add contact"
                  : "You do not have permission to add a contact"
              }
            />
            <WhiteButton
              as="RRLink"
              to="/assets/contacts/bulk"
              icon={BulkIcon}
              heading="Add"
              subheading="Bulk"
              disabled={!isUserPermitted("edit_contact")}
              title={
                isUserPermitted("edit_contact")
                  ? "Add bulk contacts"
                  : "You do not have permission to add a contact"
              }
            />
            <WhiteButton
              as="RRLink"
              to="/assets/contacts/fields"
              icon={ManageFieldIcon}
              heading="Manage"
              subheading="Field"
              disabled={!isUserPermitted("view_system_setting")}
              title={
                isUserPermitted("view_system_setting")
                  ? "Manage fields"
                  : "You do not have permission to view fields"
              }
            />
          </WhiteButtonDropdown>
        )}
      </div>
      <div>
        <div className="bg-colored-reverse p-3 rounded-3 d-flex flex-wrap align-items-end mb-3 gap-2">
          {selectedContacts.length > 0 && (
            <div>
              <label className="form-label text-nowrap fw-bold text-white p-2">
                Bulk Actions
              </label>

              <div
                className="d-flex gap-2 bg-light p-1 rounded-2 border-0"
                style={{ height: 40 }}
              >
                <button
                  type="button"
                  aria-label="Delete selected"
                  className="btn btn-outline-secondary border-0 h-100"
                  onClick={() => {
                    deleteSelected();
                  }}
                >
                  <div>
                    <span className="fw-bold me-2">Delete selected</span>
                    <FontAwesomeIcon
                      icon={faTrashCan}
                      style={{ fontSize: "1.15em" }}
                    />
                  </div>
                </button>
                <button
                  type="button"
                  aria-label="Delete all"
                  className="btn btn-outline-danger border-0 h-100"
                  onClick={handleDeleteAll}
                >
                  <div>
                    <span className="fw-bold me-2">Delete all</span>
                    <FontAwesomeIcon
                      icon={faTrashCan}
                      style={{ fontSize: "1.15em" }}
                    />
                  </div>
                </button>

                <Dropdown className="h-100">
                  <Dropdown.Toggle
                    variant="text-secondary"
                    className="btn btn-outline-secondary border-0 h-100"
                    id="editDropdown"
                  >
                    <span className="fw-bold me-2">Edit</span>
                    <FontAwesomeIcon
                      icon={faPen}
                      style={{ fontSize: "1.15em" }}
                    />{" "}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="bg-page">
                    <Dropdown.Item disabled>
                      Please select the field you want to edit
                    </Dropdown.Item>
                    {contactFields
                      .filter(
                        (cf) => !cf.isPrimary && !cf.isUnique && !cf.isHidden
                      )
                      .map((cF) => (
                        <BulkEditModal
                          contactField={cF}
                          selectedContacts={selectedContacts}
                          setFilter={setFilters}
                        />
                      ))}
                    <BulkAssignAssetsModal
                      selectedContacts={selectedContacts}
                      setFilter={setFilters}
                    />
                    <BulkAssignLocationModal
                      selectedContacts={selectedContacts}
                      setFilter={setFilters}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          )}
          <ContactsSimpleSearch
            filter={filters}
            setFilter={setFilters}
            selectedContacts={selectedContacts}
          />
        </div>
      </div>
      <div className="my-3 rounded-3">
        <Contacts
          perPage={5}
          filters={filters}
          notDraggable={() => true}
          isModal={isModal}
          setSelectedContacts={setSelectedContacts}
          contactButton={(c) => (
            <div className="d-flex gap-2">
              {isModal ? (
                <Button
                  variant="link"
                  className="align-baseline p-0"
                  title={
                    isUserPermitted("edit_contact")
                      ? "Edit contact"
                      : "View contact"
                  }
                  onClick={() => setEditedContactData({ contact: c })}
                >
                  <FontAwesomeIcon
                    icon={
                      isUserPermitted("edit_contact")
                        ? faPen
                        : faMagnifyingGlass
                    }
                  />{" "}
                </Button>
              ) : (
                <Link
                  to={`/assets/contacts/edit/${c.uuid}`}
                  title={
                    isUserPermitted("edit_contact")
                      ? "Edit contact"
                      : "View contact"
                  }
                >
                  <FontAwesomeIcon
                    icon={
                      isUserPermitted("edit_contact")
                        ? faPen
                        : faMagnifyingGlass
                    }
                  />
                </Link>
              )}
              <BulkAssignAssetsModal
                selectedContacts={[c.uuid]}
                label={
                  <span className="btn-link" title="Assign assets">
                    <FontAwesomeIcon icon={faCoins} />
                  </span>
                }
              />
            </div>
          )}
        />
      </div>
    </div>
  );
}
